export default "__VITE_ASSET__vJN3jY1C__"